import { AiOutlineClose } from "react-icons/ai";

type TVideoDisplayModalProps = {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  game: "battleRace" | "battleColour" | "battleFoot" | "battleSnake" | "battleVirus";
};

const VideoDisplayModal: React.FC<TVideoDisplayModalProps> = ({ isOpen, onClose, videoUrl, game }) => {
  if (!isOpen) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[1000] tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50 tw-cursor-pointer" onClick={onClose}>
      <div className="tw-bg-[#393B41] tw-max-w-[700px] tw-w-full tw-mx-[20px] tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-relative">
        <button className="tw-absolute tw-top-[15px] tw-right-[15px] tw-text-white tw-z-10 tw-bg-[#EA581A] tw-rounded-lg tw-p-[5px]" onClick={onClose}>
          <AiOutlineClose className="tw-w-[30px] tw-h-[30px]" />
        </button>

        <div className="tw-p-[30px] tw-pb-[20px]">
          <h2 className="tw-text-[28px] tw-font-bold tw-text-center tw-mb-[15px] add-grobold-font tw-text-white">
            {game === "battleRace"
              ? "BattleRace"
              : game === "battleColour"
              ? "BattleColour"
              : game === "battleFoot"
              ? "BattleFoot"
              : game === "battleSnake"
              ? "BattleSnake"
              : "Battle Virus"}
          </h2>
          <div className="tw-relative tw-w-full tw-h-[300px]">
            <video src={videoUrl} title="Battle Race" className="tw-w-full tw-h-full tw-rounded-[16px] tw-object-fill" controls autoPlay muted />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoDisplayModal;
